import { Pipe, PipeTransform } from '@angular/core';
import { EquipmentService } from '../../common/_services/equipment.service';

@Pipe({
  name: 'dataequipment',
  pure: true,
  standalone: false,
})
export class DataequipmentPipe implements PipeTransform {
  constructor(private equipmentService: EquipmentService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.equipmentService.getEquipmentById(Number(value));
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
